//请自行添加语言资源
const interfaceLog = {
  orderNo:'订单编号',
  msg:{
  }
};
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/log/neoLog/lang/interfaceLog.zh.js